import { useCookieState } from 'ahooks';
import { v4 as uuidv4 } from 'uuid';

const COOKIE_NAME = 'sofia_session_cookie' as const;

export default function useSessionCookie() {
  const [sessionID, setSessionID] = useCookieState(COOKIE_NAME, {
    defaultValue: uuidv4(),
    expires: 3650,
    path: '/',
    secure: true,
    sameSite: 'none', // NOTE: for an iframe
    partitioned: true, // NOTE: for chrome
  });

  const updateSessionID = (id: string) => {
    setSessionID(id);
  };

  return {
    sessionID: sessionID || '',
    setSessionID: updateSessionID,
  };
}
